export const ANCESTRY = {
  USER_AGREE_MAYBE_LATER: "user_agree_maybe_later",
  USER_AGREE: "user_agree",
  USER_CHANGE_OPINION: "user_change_opinion",
};
